var $9369d11c88c291d0$exports = {};
const $9369d11c88c291d0$var$header = document.getElementById("header");
const $9369d11c88c291d0$var$active = document.querySelector(".header--active");
$9369d11c88c291d0$var$active?.scrollIntoView({
    behavior: "smooth",
    block: "end",
    inline: "center"
});


//# sourceMappingURL=contactar.7ce9a57f.js.map
